jQuery (function () {
    // jQuery ('.account-flyout-forms__show-signup').on ('click', function () {
    //     console.log ('show signup');
// 
    //     jQuery ('.account-flyout-forms').removeClass ('show-login');
    //     jQuery ('.account-flyout-forms').addClass ('show-signup');
// 
    //     return false;
    // });
// 
    // jQuery ('.account-flyout-forms__show-login').on ('click', function () {
    //     console.log ('show login');
// 
    //     jQuery ('.account-flyout-forms').removeClass ('show-signup');
    //     jQuery ('.account-flyout-forms').addClass ('show-login');
// 
    //     return false;
    // });
// 
    // jQuery ('#show-login-forms').on ('click', function () {
// 
    //     jQuery ('.login-flyout').addClass ('show');
    //     jQuery ('.login-flyout-overlay').addClass ('show');
// 
    //     return false;
    // });

    // jQuery ('.login-flyout-overlay').on ('click', function () {
    //     
    //     jQuery ('.login-flyout').removeClass ('show');
    //     jQuery ('.login-flyout-overlay').removeClass ('show');
// 
    // });
});

